const cooperation = resolve => require(['@/page/cooperation/index'], resolve);
export default [
  {
    path: '/cooperation',
    name: 'cooperation',
    component: cooperation,
    meta: {
      title: "网站合作"
    }
  }
]